<template>
  <div>
    <!-- <v-col cols="12">
      <v-row>
        <v-col cols="6">
          <Stack/>
        </v-col>
      </v-row>
    </v-col> -->
    <v-col cols="12">
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab v-if="roles.read_overall"> Overall </v-tab>
        <v-tab
          v-if="
            roles.read_profit_store ||
            roles.read_profit_seller ||
            roles.read_profit_product
          "
        >
          Profit
        </v-tab>
        <!-- <v-tab v-if="roles.read_kpi"> KPI </v-tab> -->
        <v-tab v-if="roles.read_backend"> BackEnd </v-tab>
        <v-tab v-if="roles.read_fulfillment"> Fulfillment </v-tab>
        <v-tab v-if="roles.read_quotation"> Quotation </v-tab>
        <v-tab v-if="roles.read_vendor_selection"> Vendor Selection </v-tab>
        <v-tab v-if="roles.read_marketing_report"> Marketing </v-tab>
        <v-tab v-if="rolesIdea.read_report_idea || rolesIdea.read_report_kpi"> Idea </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-if="roles.read_overall">
          <v-card>
            <template>
              <overAll />
            </template>
          </v-card>
        </v-tab-item>

        <!-- Profit -->
        <v-tab-item
          v-if="
            roles.read_profit_store ||
            roles.read_profit_seller ||
            roles.read_profit_product
          "
        >
          <v-card>
            <template>
              <profit :userId="userId" />
            </template>
          </v-card>
        </v-tab-item>

        <!-- KPIC ompany -->
        <!-- <v-tab-item v-if="roles.read_kpi">
          <v-card>
            <kpiContainer />
          </v-card>
        </v-tab-item> -->

        <!-- Back End -->
        <v-tab-item v-if="roles.read_backend">
          <v-card>
            <backEnd />
          </v-card>
        </v-tab-item>

        <!-- Fulfillment -->
        <v-tab-item v-if="roles.read_fulfillment">
          <v-card>
            <fulfillment />
          </v-card>
        </v-tab-item>

        <!-- Quotation -->

        <v-tab-item v-if="roles.read_quotation">
          <v-card>
            <quotation />
          </v-card>
        </v-tab-item>

        <!-- vendor selection -->

        <v-tab-item v-if="roles.read_vendor_selection">
          <v-card>
            <vendorSelection />
          </v-card>
        </v-tab-item>

        <!-- Marketing -->
        <v-tab-item v-if="roles.read_marketing_report">
          <v-card>
            <marketingReport />
          </v-card>
        </v-tab-item>

        <!-- Idea -->
        <v-tab-item v-if="rolesIdea.read_report_idea || rolesIdea.read_report_kpi">
          <v-card>
            <ideaReport />
          </v-card>
        </v-tab-item>

        <!-- More -->
      </v-tabs-items>
    </v-col>
  </div>
</template>

<script>
import profit from "./Profit/c-profit-container";
//import kpiContainer from "./KPICompany/c-kpi-container";
import backEnd from "./Backend/c-backend-container";
import overAll from "./Overall/c-chart-overall";
//import Stack from "./DemoChart/c-bar-stack-chart"
import fulfillment from "./Fulfillment/c-vendor-performance.vue";
import quotation from "./Quotation/c-quotation-report.vue";
import vendorSelection from "./VendorSelection/c-vendor-selection.vue";
import marketingReport from "./Marketing/c-marketing-report.vue"
import ideaReport from "./Idea/c-idea-container.vue"

import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Dashboard",
  components: {
    profit,
    //kpiContainer,
    backEnd,
    overAll,
    fulfillment,
    quotation,
    vendorSelection,
    marketingReport,
    ideaReport,
    //Stack,
  },
  created() {
    this.$root.$refs.mainDashboard = this;
  },
  data: () => ({
    tab: null,
    showDashboard: false,
    userId: "",
    roles: [],
    rolesIdea:[],
  }),
  methods: {
    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  async mounted() {
    this.roles = await this.$cookies.get("dashboard");
    console.log("roles: ", this.roles);
    if (
      this.roles.read_overall ||
      this.roles.read_profit_store ||
      this.roles.read_profit_seller ||
      this.roles.read_profit_product ||
      this.roles.read_kpi ||
      this.roles.read_backend
    ) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    this.rolesIdea = await this.$cookies.get("idea");

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    var currentSession = await this.$root.$refs.App.currentSession(
      "main-dashboard"
    );
    this.userId = currentSession.username;
    //console.log(this.userId)
  },
};
</script>
